import { useState } from 'react'
import Sample from '../components/Render.jsx'
import { Navbar } from '../components/Navbar.tsx';
import PDF from '../assets/tuto.pdf';

export default function Doc(){
    const [fileUrl, setFileUrl] = useState(PDF)

    return(
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: 'var(--background-muted)' }}>
            <Navbar />
            <div className="container" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '2rem 5%' }}>
                <Sample file={fileUrl} />
            </div>
        </div>
    )
}